import React, { JSX, useState } from 'react';
import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import Icons from '../atoms/Icons';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';
import { StyleguideComponentProps } from 'lib/component-props';

type AccordionProps = StyleguideComponentProps & {
  fields: {
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
    AccordionHeader: Field<string>;
    AccordionDescription: Field<string>;
    AccordionList: Array<AccordionDataContent>;
  };
};

type AccordionDataContent = {
  id: string;
  fields: {
    BaseHeading: Field<string>;
    BaseHeadingH2: {
      value: boolean;
    };
    BaseDescription: Field<string>;
    BaseBackground: {
      value: boolean;
    };
  };
};

const Accordion = (props: AccordionProps): JSX.Element => {
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  const [activeKey, setActiveKey] = useState<string>('');

  const setActiveAccordion = (id: string) =>
    setActiveKey(activeKey === id ? '' : id);

  if (!props.fields) {
    return <p>No datasource set</p>;
  }

  return (
    <div
      className={classNames('overhauled', marginSize)}
      id={`accordion-${props.rendering?.uid}`}
    >
      <div className="accordion-container">
        <div className="jss-inner-container">
          {props.fields?.AccordionHeader?.value && (
            <h2 className="accordion-top-header">
              {props.fields.AccordionHeader.value}
            </h2>
          )}
          {props.fields?.AccordionDescription?.value && (
            <RichText
              className="accordion-top-description osf-body-copy"
              tag="div"
              field={props.fields.AccordionDescription}
            />
          )}
          <div className="accordion">
            {props?.fields &&
              props?.fields?.AccordionList?.map(({ id, fields }, index) => {
                return (
                  <div
                    key={index}
                    className={`accordion-item ${id === activeKey ? 'active' : ''} ${fields?.BaseBackground?.value ? 'background' : ''}`}
                  >
                    <div
                      className={`accordion-header ${
                        fields?.BaseBackground?.value
                          ? 'background bg-secondary'
                          : ''
                      }`}
                      onClick={() => setActiveAccordion(id)}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          setActiveAccordion(id);
                        }
                      }}
                      tabIndex={0}
                    >
                      <h3 className="accordion-label osf-display-h3">
                        {fields?.BaseHeading?.value}
                      </h3>
                      <Icons id="chevron-down" />
                    </div>
                    <div className="accordion-content-wrapper">
                      <RichText
                        tag="div"
                        field={fields?.BaseDescription || ''}
                        className={classNames(
                          'accordion-content osf-body-copy'
                        )}
                      />
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Accordion;
